import { assertIsTrue } from '../../../../lib/test-and-assert/assert-base';
import { assertIsInputStatusApi } from '../assert';
import { testIsRawInputInfo } from '../test';
import { INPUT_STATUS_API_READY } from '../consts';

/**
 * Helper class which parses the server response of the type 'jobinfo'
 *
 * @param {RawInputInfo} rawInputInfo The type of the input
 *
 * @constructor
 */
function InputInfoHelper(rawInputInfo) {
    this._isValid = true;
    this._rawData = {};

    if (!testIsRawInputInfo(rawInputInfo)) {
        this._isValid = false;

        return;
    }

    /** @type {RawInputInfo} */
    this._rawData = rawInputInfo;
}

/**
 * @return {boolean}
 */
InputInfoHelper.prototype.isValid = function () {
    return this._isValid;
};

/**
 * @return {string}
 */
InputInfoHelper.prototype.getId = function () {
    assertIsTrue(this._isValid);

    return this._rawData.id;
};

/**
 * @return {number}
 */
InputInfoHelper.prototype.getSize = function () {
    assertIsTrue(this._isValid);

    return this._rawData.size;
};

/**
 * @return {string}
 */
InputInfoHelper.prototype.getStatus = function () {
    assertIsTrue(this._isValid);
    assertIsInputStatusApi(this._rawData.status);

    return this._rawData.status;
};

// TODO T3506  add support for all api input status here: isFailed, isReady, isCanceled, ...

/**
 * @return {boolean}
 */
InputInfoHelper.prototype.isFinished = function () {
    assertIsTrue(this._isValid);

    /** @type {RawInputInfo} */
    var rawData = this._rawData;

    return rawData.status === INPUT_STATUS_API_READY;
};

export { InputInfoHelper };
